export default "__VITE_ASSET__9cdd72af__"